/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Search_ErrorInputs */

const en_domain_search_modal_search_error = /** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to search for domains`)
};

const es_domain_search_modal_search_error = /** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al buscar dominios`)
};

const fr_domain_search_modal_search_error = /** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la recherche de domaines`)
};

const de_domain_search_modal_search_error = /** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler bei der Suche nach Domains`)
};

/** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */
const ja_domain_search_modal_search_error = en_domain_search_modal_search_error;

/** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */
const zh_domain_search_modal_search_error = en_domain_search_modal_search_error;

/** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */
const ar_domain_search_modal_search_error = en_domain_search_modal_search_error;

/** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */
const id_domain_search_modal_search_error = en_domain_search_modal_search_error;

/** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */
const it_domain_search_modal_search_error = en_domain_search_modal_search_error;

/** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */
const ru_domain_search_modal_search_error = en_domain_search_modal_search_error;

/** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */
const pt_domain_search_modal_search_error = en_domain_search_modal_search_error;

/** @type {(inputs: Domain_Search_Modal_Search_ErrorInputs) => LocalizedString} */
const ko_domain_search_modal_search_error = en_domain_search_modal_search_error;

/**
* | output |
* | --- |
* | "Failed to search for domains" |
*
* @param {Domain_Search_Modal_Search_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_search_error = /** @type {((inputs?: Domain_Search_Modal_Search_ErrorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Search_ErrorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_search_error(inputs)
	if (locale === "es") return es_domain_search_modal_search_error(inputs)
	if (locale === "fr") return fr_domain_search_modal_search_error(inputs)
	if (locale === "de") return de_domain_search_modal_search_error(inputs)
	if (locale === "ja") return ja_domain_search_modal_search_error(inputs)
	if (locale === "zh") return zh_domain_search_modal_search_error(inputs)
	if (locale === "ar") return ar_domain_search_modal_search_error(inputs)
	if (locale === "id") return id_domain_search_modal_search_error(inputs)
	if (locale === "it") return it_domain_search_modal_search_error(inputs)
	if (locale === "ru") return ru_domain_search_modal_search_error(inputs)
	if (locale === "pt") return pt_domain_search_modal_search_error(inputs)
	return ko_domain_search_modal_search_error(inputs)
});